export const ROUTES = {
  home: "/",
  exam: "/exam",
  dashboard: "/dashboard",
  exams: "/exams",
  documents: "/documents",
  practice: "/practice",
  legalDocuments: "/legal-documents",
  forgotPassword: "/forgot-password",
  resetPassword: "/auth/update-password",
  impersonateUser: "/impersonate-user",
  professionalTraining: "/professional-training",
};
